import { ConfigService } from '../../lib/config/config.service';

export const initAppVersion = (document: Document) =>  {
  document.body.setAttribute("app-version", ConfigService.environmentGlobal.appVersion);
}
